module.exports = __webpack_public_path__ + "static/media/btn-instrument-pitch.63c19abe.svg";